import * as angular from 'angular';
import nvBuildsModule from '../nv.builds.module';
import { PortalLastUpdatedInterceptorService } from './portal-last-updated-interceptor.service';

export default angular
  .module('InterceptorsModule', [nvBuildsModule])
  .service('PortalLastUpdatedInterceptor', PortalLastUpdatedInterceptorService).name;
